import { render } from "./ConfigurationItems.vue?vue&type=template&id=01e1e0f2&scoped=true&ts=true"
import script from "./ConfigurationItems.vue?vue&type=script&lang=ts"
export * from "./ConfigurationItems.vue?vue&type=script&lang=ts"

import "./ConfigurationItems.vue?vue&type=style&index=0&id=01e1e0f2&scoped=true&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e1e0f2"]])

export default __exports__